import { t } from '../../common/components/T';

export const getFormData = (currency, activeLangs, formData, translation, isStorePage, userToken, display_country) => {
    return [
        {
            attribute: 'country',
            group: 'main_info',
            title: {
                body: t('SiteSettings-Country', 'Страна', 'widget', translation, 'SiteSettings')
            },
            maxMenuHeight: 240,
            name: 'country',
            placeholder: t('SiteSettings-ChooseCountry', 'Выберите страну', 'widget', translation, 'SiteSettings'),
            type: 'location_widget',
            value: formData['country'] || null
        },
        {
            attribute: 'language',
            group: 'main_info',
            disabled: activeLangs?.length <= 1,
            options: activeLangs?.map((el) => ({
                id: el.alias,
                title: el.name
            })),
            title: {
                body: t('SiteSettings-Language', 'Язык', 'widget', translation, 'SiteSettings')
            },
            name: 'language',
            placeholder: t('SiteSettings-ChooseLanguage', 'Выберите язык', 'widget', translation, 'SiteSettings'),
            value: formData['language'] || null,
            type: 'dropdown'
        },
        ...(isStorePage && userToken
            ? []
            : [
                  {
                      attribute: 'currency',
                      group: 'main_info',
                      options: currency || [],
                      title: {
                          body: t('SiteSettings-Currency', 'Валюта', 'widget', translation, 'SiteSettings')
                      },
                      name: 'currency',
                      placeholder: t('SiteSettings-ChooseCurrency', 'Выберите валюту', 'widget', translation, 'SiteSettings'),
                      type: 'dropdown',
                      noTranslate: true,
                      value: formData['currency'] || null
                  }
              ]),
        ...(userToken
            ? [
                  {
                      attribute: 'display_country',
                      type: 'checkbox',
                      title: {
                          body: t(
                              'SiteSettings-ChooseDisplayCountry',
                              'Отображать структуру моей страны',
                              'widget',
                              translation,
                              'SiteSettings'
                          )
                      },
                      value: display_country
                  }
              ]
            : [])
    ];
};
